module.exports = "<app-photo-edit photo-list=$ctrl.poi.photos main-lang=$ctrl.poi.main_lang ng-form name=poiEditPhotoForm> </app-photo-edit> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/photos/partial.html
// module id = 440
// module chunks = 0